<template>
  <ul
    id="desktop-menu"
    class="items-stretch self-stretch hidden text-base md:flex"
  >
    <li class="hidden flex items-center">
      <a
        class="relative.text-gray-600 hover:text-gray-700 hover:no-underline"
        href="#"
      >
        <i class="mdi mdi-bell-outline"></i>
        <span class="sr-only">Alerts</span>
        <span
          class="absolute top-0 right-0 block w-2 h-2 border border-2 border-white rounded-full alert bg-error-900"
        ></span>
      </a>
    </li>
    <li class="relative flex items-center ml-6">
      <button
        class="flex items-center text-base text-gray-600 hover:text-gray-700 hover:no-underline focus:outline-none"
        v-if="!isMaintenanceMode"
        aria-controls="user-menu"
        aria-label="Toggle Desktop Menu"
        :aria-expanded="open"
        data-toggle-indicator="flip"
        @click="$store.commit('toggleMenu')"
      >
        <span class="mr-2">Hi {{ name }}</span>
        <i class="mdi mdi-chevron-down" v-if="!open"></i>
        <i class="mdi mdi-chevron-up" v-if="open" ></i>
      </button>
      <div
        id="user-menu"
        class="absolute right-0 w-48 bg-white shadow-lg menu top-full"
        v-if="open"
      >
        <ul class="py-2 text-sm">
          <li class="border-t border-gray-200">
            <router-link
              class="block px-4 py-3 font-normal text-gray-600 hover:bg-blue-300 hover:text-gray-700 hover:no-underline"
              to="/my-students"
            >
              My Students
            </router-link>
          </li>

          <li class="border-t border-gray-200">
            <router-link
              class="block px-4 py-3 font-normal text-gray-600 hover:bg-blue-300 hover:text-gray-700 hover:no-underline"
              to="/notification-settings"
              >Notification Settings</router-link
            >
          </li>
          <li class="border-t border-gray-200">
            <a
              class="block px-4 py-3 font-normal text-gray-600 hover:bg-blue-300 hover:text-gray-700 hover:no-underline"
              href="#"
              @click="$emit('logout')"
              >Logout</a
            >
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "desktopMenu",
  computed: {
    isMaintenanceMode() {
      return (
        process.env.VUE_APP_MAINTENANCE_MODE &&
        process.env.VUE_APP_MAINTENANCE_MODE.toLowerCase() === "true"
      );
    },
    name() {
      return this.$store.getters.getUserName;
    },
    open() {
      return this.$store.getters.isMenuOpen;
    },
    auth() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>
